<div class="drop-area" fxLayout="row" fxLayoutAlign="space-between center" appDragNDropFiles (fileDropped)="onFileDropped($event)">
  <input title="" type="file" #fileDropRef id="fileDropRef" multiple (change)="onFileDropped($event.target.files)"/>
  <h3>Drag and drop files here</h3>
  <h3>&#x00A0;</h3>
  <div fxLayout="row">
    <label for="fileDropRef">Browse</label>
    <button *ngIf="!hideUploadButton" type="button" (click)="uploadFiles($event)" class="label" [disabled]="disableUpload(files)">Upload</button>
  </div>
  <div class="files-list">
    <mat-progress-bar [hidden]="!fileLoading" mode="indeterminate"></mat-progress-bar>
    <div [hidden]="fileLoading" class="file-item" *ngFor="let file of files; let i = index; let count = count">
      <h4 class="name">{{file.name}}<span>{{i==count-1 ? '': ','}}</span></h4>
      <mat-icon class="delete" (click)="deleteFile(i)" [hidden]="file.uploaded">highlight_off</mat-icon>
    </div>
  </div>
</div>
